// extracted by mini-css-extract-plugin
export default {"btop":"_2b229bfc14 b7303fabaf _6952407ee1","icon":"_9079c4a961 _36814b9807","btoppink":"bcd5628699 _4973b5f826"};